import { navigateTo } from '#imports'

import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { isBrowser } from '@backmarket/utils/env/isBrowser'

import { useSaveBouyguesAddress } from '~/scopes/checkout/composables/useSaveBouyguesAddress'
import { CHECKOUT } from '~/scopes/checkout/routes-names'

export function useRedirectIfAddressNeedsBouyguesNormalization() {
  const logger = useLogger()
  const { saveBouyguesAddress } = useSaveBouyguesAddress()

  const redirectIfAddressNeedsBouyguesNormalization = async (
    addressList: ApiSpecs['/bm/cart']['GET']['response']['addressList'],
  ) => {
    if (!addressList.deliver || !addressList.bill) {
      logger.info(
        '[CHECKOUT] [BOUYGUES] Address list is missing deliver or bill address.',
        {
          owners: ['bot-squad-checkout-front', 'bot-squad-b2cservices-front'],
        },
      )

      await navigateTo({ name: CHECKOUT.SHIPPING_ADDRESS })

      return
    }

    if (isBrowser()) {
      try {
        await Promise.all([
          saveBouyguesAddress(addressList.deliver, 'SHIPPING'),
          saveBouyguesAddress(addressList.bill, 'BILLING'),
        ])
      } catch {
        logger.info(
          '[CHECKOUT] [BOUYGUES] User shipping address needs normalization. Redirecting to shipping address step.',
          {
            owners: ['bot-squad-checkout-front', 'bot-squad-b2cservices-front'],
          },
        )

        await navigateTo({ name: CHECKOUT.SHIPPING_ADDRESS })
      }
    }
  }

  return { redirectIfAddressNeedsBouyguesNormalization }
}
